import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import notice from './notice'
import technique from './technique'
import book from './book'
import school from './school'
import message from './message'
import utils from './utils'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    user,
    notice,
    technique,
    book,
    utils,
    school,
    message
  },
  state: {
  },
  mutations: {
  },
  actions: {
  },
})

store.dispatch('user/checkAuth')

export default store